import { createTheme } from '@mui/material/styles';


export const Colors = {
  primary: "#163A59", // "#4B32A6", //"#5f2c3e", 
  secondary: "#d1adcc",
  success: "#4CAF50",
  info: "#00a2ff",
  danger: "#FF5722",
  warning: "#FFC107",
  dark: "#0e1b20",
  light: "#aaa",
  muted: "#abafb3",
  border: "#DDDFE1",
  inverse: "#2F3D4A",
  shaft: "#333",


  ///////////////
  // Menu button, 
  ///////////////
  menu_button: "#32738C",

  ///////////////
  // Grid color header, alt
  ///////////////
  grid_header: "#32738C", //"#4B32A6", //"#A68695",
  grid_alt: "#B6ECF2", // "#7350F2", //"#d1adcc",

  ///////////////
  // Grays
  ///////////////
  dim_grey: "#696969",
  dove_gray: "#d5d5d5",
  body_bg: "#f3f6f9",
  light_gray: "rgb(230,230,230)",
  ///////////////
  // Solid Color
  ///////////////
  white: "#fff",
  black: "#000",


};


export const theme = createTheme({
    typography : {
      fontFamily: ["Arial"].join(","),
      button: {
        textTransform: 'none'
      }
    },
    components: {
      MuiTypography: {
        styleOverrides: {
            // Name of the slot
            root: {
              // Some CSS
              paddingTop: '4px',
              paddingBottom: '4px',
            },
          },
      },

      MuiButtonBase: {
        defaultProps: {
          // The default props to change
          disableRipple: true, // No more ripple, on the whole application 💣!
        },
      },
      // Name of the component
      MuiButton: {
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            fontSize: '1rem',
          },
        },
      },
  
      MuiFormControl: {
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            margin: '2px',
          },
        },
      },
  
      MuiInputBase: {
        styleOverrides: {
          // Name of the slot
          input: {
            // Some CSS
            padding: '0px',
          },
        },
      },
      
  
      MuiTextField: {
        defaultProps: {     
             
          variant: 'standard',
          
          sx: {marginTop: '2px', marginLeft: '8px', marginRight: '8px',},
          InputLabelProps: {
            shrink:true
          },
          inputProps: {
            autoComplete: 'new-password',
            style: {textTransform: 'uppercase'}
         }
        },
      },
  
      MuiCheckbox: {
        defaultProps: {     
          size: 'small'
        },
        styleOverrides: {
          // Name of the slot
          root: {
            // Some CSS
            minWidth: '24px',
            padding: '0px',
            
          },
        },
      },
  
      MuiListItem: {
        defaultProps: { 
          dense: true,
          sx: {paddingTop: '2px', paddingBottom: '2px' },        
        },
  
        styleOverrides: {
          root: {
            paddingLeft: '8px',
          },
        },
      },
  
      MuiListItemIcon: {
        defaultProps: {                 
        },
  
        styleOverrides: {
          root: {
            minWidth: '24px',
          },
        },
      },
  
  
  
  
      MuiListSubheader: {
        styleOverrides: {
          root: {
            lineHeight: '32px',
            paddingLeft: '8px',
            paddingRight: '8px',
            paddingBottom: '4px',
            paddingTop: '4px'
          },
        },
      },
  
      MuiFormControlLabel: {
        styleOverrides: {
          root: {
            marginLeft: '2px',
            marginRight: '2px',
            marginTop: '14px'
          },
        },
      },
      
      MuiDialogTitle: {
        styleOverrides: {
          root: {
            paddingTop: '8px',
            paddingBottom: '8px',
            paddingLeft: '8px',
            paddingRight: '8px',
          },
        },
      },
  
      MuiDialogContent: {
        styleOverrides: {
          root: {
            paddingTop: '8px',
            paddingBottom: '8px',
            paddingLeft: '8px',
            paddingRight: '8px',
          },
        },
      },
  
      MuiToolbar: {
        styleOverrides: {
          root: {
            minHeight: '32px',
            height: '32px',
            '@media (min-width: 0px)': {
                minHeight: '32px',
              },
            '@media (min-width: 600px)': {
                minHeight: '32px',
                paddingRight: '0px',
            },
              
          }
        }
      }
  
    },
  });